import { useLogiConfig, useLogiReportsTranslation } from '../../../../ui/hooks';
import { PageError } from '@juvare/common-web-ui/PageError';
import { PageHeaderWithImage } from '@juvare/common-web-ui/PageHeader';
import { LogiInventoryVisual } from '@juvare/logi-library';
import { CircularProgress } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router';
export const VisualList = ({ hideHeader }) => {
    const { t } = useLogiReportsTranslation();
    const navigate = useNavigate();
    const { data, isLoading, error } = useLogiConfig();
    if (isLoading) {
        return React.createElement(CircularProgress, null);
    }
    if (error) {
        return React.createElement(PageError, { error: error });
    }
    if (!data) {
        return React.createElement(PageError, { message: t('common.error') });
    }
    return (React.createElement(React.Fragment, null,
        !hideHeader && React.createElement(PageHeaderWithImage, { gradient: 'blue-base', title: t('panels.visuals.title') }),
        React.createElement(LogiInventoryVisual, { configuration: Object.assign(Object.assign({}, data.componentConfig), { interactivityOverrides: {
                    visualSettings: {},
                    settings: {
                        ['TAGS']: true,
                        ['PERMISSIONS']: true,
                    },
                }, components: {
                    actions: {
                        definitions: [{ id: 'add-new-visual', onClick: () => navigate('new', { state: { back: true } }) }],
                    },
                    filters: {},
                    search: {},
                    searchByField: {},
                    table: {
                        columns: {
                            definitions: [
                                {
                                    colId: 'name',
                                    cellRendererParams: {
                                        onClick: (data) => data && navigate(data.inventoryItemId, { state: { back: true, visualName: data.name } }),
                                    },
                                },
                            ],
                        },
                    },
                } }), getToken: data.getToken, logiBaseUrl: data.logiBaseUrl })));
};
